import React from 'react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';

/**
 * withRouter HOC for React Router v6
 * Provides compatibility with React Router v5 withRouter API
 */
export function withRouter<TProps = any, TParams = any>(Component: any) {
  function ComponentWithRouterProp(props: TProps) {
    let location = useLocation();
    let navigate = useNavigate();
    let params = useParams();
    
    return (
      <Component
        {...(props as TProps)}
        router={{ location, navigate, params }}
        location={location}
        navigate={navigate}
        params={params as unknown as TParams}
        history={{
          push: navigate,
          replace: (path: string) => navigate(path, { replace: true }),
          go: (n: number) => navigate(n),
          goBack: () => navigate(-1),
          goForward: () => navigate(1),
          location: location
        }}
        match={{ params }}
      />
    );
  }

  return ComponentWithRouterProp;
}

export default withRouter;
